import React, {useEffect, useState} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {Button, Dialog, DialogContent, DialogTitle, Stack, Typography,} from '@mui/material';
import {yupResolver} from '@hookform/resolvers/yup';
import {useCreateNC, validationSchemaNC} from './Services';
import {NC} from './types';
import * as Yup from "yup";
import {FormField} from '../../common/FormField';
import {useFieldsNC_1, useFieldsNC_2, useFieldsNC_3, useFieldsNC_4} from './FormNC';
import {useGetDropProgettiByCodDip} from "../../common/Services";

interface AddNCProps {
  open: boolean;
  onClose: () => void;
  defaultDate?: Date | null;

}

const AddNC: React.FC<AddNCProps> = ({ open, onClose   }) => {

      type NCForm = Yup.InferType<typeof validationSchemaNC>


  const { control, handleSubmit, reset,watch,setValue, formState: { errors } } = useForm<NCForm>({
    resolver: yupResolver(validationSchemaNC),
     defaultValues: {
              ditta: 2,
              coddip: "",
              titolo: "",
              note: "",
              idcatnc: 0,
              idstatonc: 0,
              idlivellonc: 0,
              dataapertura: new Date(),
              datachiusura: null,
              auditor: "",
              idprog: "",
            },
  });

      // console.log(errors);



  const f1 = useFieldsNC_1();
  const f2 = useFieldsNC_2();
  const f3 = useFieldsNC_3(setValue);
  const f4 = useFieldsNC_4();

  const { mutateAsync, isPending } = useCreateNC();

  const onSubmit: SubmitHandler<NCForm> = async data => {
    // console.log("FINAL FORM DATA:", data);

    const payload = {
                  ...data,
                };

    await mutateAsync(payload as NC);
    onClose();
  };





  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">Nuova NC</Typography>
      </DialogTitle>

      <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
    <Stack direction="row" spacing={1}>{f1.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
    <Stack direction="row" spacing={1}>{f2.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
    <Stack direction="row" spacing={1}>{f3.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
    <Stack direction="row" spacing={1}>{f4.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>

              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                          <Button onClick={onClose} color="error">Annulla</Button>
                          <Button type="submit" variant="contained" disabled={isPending }>
                              {isPending ? 'Salvando…' : 'Salva'}
                          </Button>
                      </Stack>

          </form>
      </DialogContent>
    </Dialog>

  </>

  );
};

export default AddNC;
